import { useSearchParams } from 'react-router-dom';

/**
 * Returns a function that sets or clears a single URL search param (a falsy
 * value deletes it) without touching any other params, using `replace: true`
 * so search/pagination/filter updates don't pollute browser history.
 */
export const useSetSearchParam = () => {
  const [, setSearchParams] = useSearchParams();

  return (key: string, value: string) =>
    setSearchParams(
      (prev) => {
        const updated = new URLSearchParams(prev);

        if (value) updated.set(key, value);
        else updated.delete(key);

        return updated;
      },
      { replace: true },
    );
};
